const API_BASE = import.meta.env?.VITE_API_BASE_URL || '/api/v1';

function getToken() {
  return localStorage.getItem('rmt-token') || 'demo-token';
}

/**
 * Thin fetch wrapper for the real-mode-test JSON API.
 * Adds JSON and bearer-token headers, throws on non-2xx, and parses JSON.
 */
export async function apiFetch(path, options = {}) {
  const url = `${API_BASE}${path}`;
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    ...(options.headers || {}),
  };
  if (!headers.Authorization) {
    headers.Authorization = `Bearer ${getToken()}`;
  }

  const response = await fetch(url, { method: 'GET', ...options, headers });
  if (!response.ok) {
    const body = await response.text().catch(() => '');
    throw new Error(`API ${options.method || 'GET'} ${path} failed: ${response.status} ${body}`);
  }
  return response.status === 204 ? null : response.json();
}
